import { render, staticRenderFns } from "./goods_setting.vue?vue&type=template&id=725009c6&"
import script from "./goods_setting.vue?vue&type=script&lang=js&"
export * from "./goods_setting.vue?vue&type=script&lang=js&"
import style0 from "./goods_setting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports